import React from 'react';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import styles from './Header.module.css';

export default function Header() {
    return (
        <section className={styles.headerLayout}>
            <div className={styles.imageContainer}>
                <img
                    className={styles.heroImage}
                    alt="Person wearing a futuristic VR headset in a blue lit room"
                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuDSBvqgMGJG_SNaT18YBsY03iCHwIEOcWsUqNgXJR4ElPyNvD-FVxFFNmNMBEHFSRgt9feU251v0e8XqCdOOEzi04gPRxKgmSKJEjCFUQusSrerpxXspy-s9aTPn2UKep7Qd2khRljkhkharw6iZj_SG09dOp2sRcQD5k69cP9KnXVw9hMSR3RtzG3ICiyoGlOydmd_SkNyE3Arv7oxnEmQx6z_WuzE3GwnRaDZDEtNLtJY3EFy1MFJY-9RWSN0KDOSRKQIwf8gJpTF"
                    referrerPolicy="no-referrer"
                />
                <div className={styles.overlay}></div>
            </div>
            <div className={styles.contentContainer}>
                <div className={styles.textContent}>
                    <span className={styles.badge}>
                        IMMERSIVE LEARNING DONE RIGHT
                    </span>
                    <h1 className={styles.title}>
                        Explore. Experience. Understand.
                    </h1>
                    <p className={styles.description}>
                        Curated, interactive learning experiences designed to make complex ideas easy to understand — from inside a heart, to the credit system.
                    </p>
                    {/* <div className={styles.buttonGroup}>
                        <Link to="/library" className={styles.primaryButton}>
                            Explore Library <FontAwesomeIcon icon={faArrowRight} className={styles.icon} />
                        </Link>
                    </div> */}
                </div>
            </div>
        </section>
    );
}